import { createReducer, on } from '@ngrx/store';
import { ContactsActions, RouterActions, AppActions } from '@actions/index'
import { ContactModel, ResultBulkAddModel } from '@models/index';

export interface State {
  contacts: ContactModel[];
  contactAdded: boolean;
  bulkAdded: boolean;
  total: number;
  error: string;
  resultBulkAdd: ResultBulkAddModel;
  isContactExport: boolean
  exportDataContactCount: number;
}

const initialState: State = {
  contacts: [],
  contactAdded: false,
  total: 0,
  error: "",
  bulkAdded: false,
  resultBulkAdd: {
    status: "",
    message: "",
    data: "",
    countAdded: 0,
    countExist: 0
  },
  isContactExport: false,
  exportDataContactCount: 0
};

export const reducer = createReducer(
  initialState,
  on(ContactsActions.searchContactsSuccess, (state, { total, data }) => ({ ...state, contacts: data, total })),
  // on(ContactsActions.searchContactsByBusiness, (state) => ({ ...state, contacts: [], total: 0 })),
  // on(ContactsActions.searchContactsByLocation, (state) => ({ ...state, contacts: [], total: 0 })),
  on(ContactsActions.createContacts, (state, { contact }) => ({ ...state, contactAdded: false })),
  on(ContactsActions.createContactsSuccess, (state, { contact }) => ({
    ...state, contacts: [
      contact, ...state.contacts.filter(item => item.id != contact.id)
    ],
    total: state.total + 1,
    contactAdded: true
  })),
  on(ContactsActions.setContactAdded, (state, { contactAdded }) => ({ ...state, contactAdded: false })),
  on(ContactsActions.editContactSuccess, (state, { contact }) => ({ ...state, contacts: [...state.contacts, contact].filter(item => item.id !== contact.revisions[contact.revisions.length - 1]) })),
  on(ContactsActions.deleteContactSuccess, (state, { contactId }) => ({ ...state, contacts: state.contacts.filter((contact) => contact.id != contactId), total: state.total - 1 })),
  on(ContactsActions.contactError, (state, { error }) => ({ ...state, error })),
  on(RouterActions.navigateAuth, () => ({ ...initialState })),
  on(AppActions.clearState, (state) => {
    return ({
      ...state,
      contacts: [],
      total: 0,
    })
  }),
  on(ContactsActions.bulkAddContacts, (state) => ({
    ...state,
    bulkAdded: false,
  })),
  on(ContactsActions.bulkAddContactsSuccess, (state, { result }) => ({
    ...state,
    bulkAdded: true,
    resultBulkAdd: {
      status: result.status,
      message: result.message,
      data: result.data,
      countAdded: state.resultBulkAdd.countAdded + result.countAdded,
      countExist: state.resultBulkAdd.countExist + result.countExist
    }
  })),
  on(ContactsActions.clearResultBulkAdd, (state) => ({
    ...state,
    bulkAdded: false,
    resultBulkAdd: {
      status: "",
      message: "",
      data: "",
      countAdded: 0,
      countExist: 0,
    }
  })),
  on(ContactsActions.setExportDataContact, (state, { isExporContact }) => ({
    ...state,
    isContactExport: isExporContact,
    error: "",
    exportDataContactCount: 0
  })),
  on(ContactsActions.exportDataContact, (state) => ({
    ...state,
    isContactExport: false,
    error: ""
  })),
  on(ContactsActions.exportDataContactSuccess, (state) => ({
    ...state,
    isContactExport: true,
  })),
  on(ContactsActions.exportDataContactCount, (state) => ({
    ...state,
    exportDataContactCount: 0,
  })),
  on(ContactsActions.exportDataContactCountSuccess, (state, { data }) => ({
    ...state,
    exportDataContactCount: data.count,
  })),
);


export const getContacts = (state: State) => state.contacts;
export const getContactAdded = (state: State) => state.contactAdded;
export const getTotal = (state: State) => state.total;
export const getError = (state: State) => state.error;
export const isBulkAdded = (state: State) => state.bulkAdded;
export const resultBulkAdd = (state: State) => state.resultBulkAdd;
export const isContactExport = (state: State) => state.isContactExport;
export const exportDataContactCount = (state: State) => state.exportDataContactCount;
